import { useContext, useEffect, useRef, useState } from 'react'
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { signInFormData } from '../../data/formData';
import { makePatchCall, makePostCall, makePutCall } from '../../effects/requests';
import { ApiResponseType, PERMISSION_TYPE, ROLE_TYPE } from '../../types';
import { apiConstants } from '../../utils/apiConstants';
import { emptyFunction, getRoute, showToast } from '../../utils';
import { cookieServiceParam, errorMessage, labels, placeholder } from '../../utils/constants';
import { EMAIL_VALIDATION, REQUIRED_VALIDATION } from '../../lib/input/validation-rules';
import { endPoints } from '../../utils/endpoints';
import { MyContext } from '../../context';
import ChangePassword from "../../components/modal/changePassword";
import { cookieService } from '../../services';
import { setToken } from '../../global/FCM/FCM';
import InputFieldV2 from '../../lib/input/InputFieldV2';

const SignIn = () => {

  const { updateUserData } = useContext(MyContext)

  const location = useLocation();
  const isProductionOwner = location?.state?.is_production_owner || false

  const { ...methods } = useForm({
    mode: 'all',
    defaultValues: { ...signInFormData() },
    reValidateMode: 'onBlur'
  });

  const navigate = useNavigate();
  const userInfo = useRef<any>(null)

  const [isEmailExists, setIsEmailExists] = useState<Boolean>(false);
  const [userName, setUserName] = useState(null);
  const [isSecure, setIsSecure] = useState<any>(true);
  const [showPassChangeModal, setShowPassChangeModal] = useState<any>(false);
  const userType = cookieService.getCookie(cookieServiceParam.userType);
  const isProductionSignUp = userType === ROLE_TYPE.TYPE_CREW
  const [existUserType, setExistUserType] = useState(null);

  useEffect(() => {
    if (isProductionSignUp) {
      setIsEmailExists(true)
    }
  }, [])
  const onSubmit: SubmitHandler<any> = (data: any) => {
    if (isEmailExists) {
      onSignIn(methods.getValues());
    } else (
      checkEmailExists()
    )
  };

  const onSignIn = (data: any) => {
    makePostCall(endPoints.LOGIN, data).then((res: ApiResponseType<any>) => {
      if (res.status?.code == 200) {
        if (!res?.data?.is_password_changed) {
          userInfo.current = res;
          cookieService.saveCookie(cookieServiceParam.token, res?.token?.access || "");
          setShowPassChangeModal(true)
          return
        }
        navigate('/mfa-authentication', { state: { loginRes: res, isProductionOwner: isProductionOwner } })
        // cookieService.saveCookie(cookieServiceParam.token, res?.token?.access || "");
        // cookieService.saveCookie(cookieServiceParam.userType, res?.data?.user_type)
        // cookieService.saveCookie(cookieServiceParam.account_completed, res?.data?.account_completed);
        // cookieService.saveCookie(cookieServiceParam.subscription_id, res?.data?.subscription_id)
        // regDeviceToken()
        // userNavigate(res)
      }
    }).catch(emptyFunction)
  }

  const regDeviceToken = async () => {
    const params: any = { device_type: 'WEB' }
    if (cookieService.getCookie(cookieServiceParam.browserToken)) {
      params.token = cookieService.getCookie(cookieServiceParam.browserToken)
    } else {
      const fcmToken = await setToken(emptyFunction);
      params.token = fcmToken
    }
    if (!params?.token) return
    makePostCall(endPoints.DEVICE_TOKEN, params).then(emptyFunction).catch(emptyFunction)
  }

  const userNavigate = (res: any) => {
    if (Array.isArray(res?.data?.crew_member_profile?.company_department) && res?.data?.crew_member_profile?.company_department?.length > 0) {
      res?.data?.crew_member_profile?.company_department?.map((item: any) => {
        item.label = item?.dep;
        item.value = item?.dep;
      })
    }
    updateUserData(res);
    let routeUrl = null;
    if (res?.data?.user_type === ROLE_TYPE.TYPE_CREW && res?.data?.account_completed) {
      if (!isProductionOwner && res?.data?.permission_type === PERMISSION_TYPE.TYPE_CREW_MEMBER) {
        routeUrl = '/schedule';
      } else if (res?.data?.permission_type === PERMISSION_TYPE.TYPE_CREW_MEMBER && isProductionOwner) {
        makePatchCall(endPoints.PROFILE, { permission_type: PERMISSION_TYPE.TYPE_PROD_OWNER })
          .then((res) => {
            routeUrl = '/manage-profile/owner/add/1'
            navigate(routeUrl)
            return;
          })
          .catch((err) => { })
      } else if (res?.data?.permission_type === PERMISSION_TYPE.TYPE_PROD_OWNER) {
        routeUrl = getRoute(res.data);
      } else {
        routeUrl = '/schedule';
      }
    } else {
      routeUrl = getRoute(res.data);
    }
    navigate(routeUrl as never);
  }

  const checkEmailExists = () => {
    const payload = { email: methods.getValues(apiConstants.email) }
    makePostCall(endPoints.CHECKEMAIL, payload).then((res: ApiResponseType<any>) => {
      if (res.status?.code == 200) {
        // if (res.data?.user_type == ROLE_TYPE.TYPE_CREW && res.data?.permission_type == ROLE_TYPE.TYPE_CREW) {
        //   showToast(errorMessage.unauthorized_access, "error");
        //   return
        // }
        setUserName(res.data?.full_name);
        setIsEmailExists(!res.data?.available);
        setExistUserType(res?.data?.user_type || "")
        setTimeout(() => methods.setValue(apiConstants.password, ""), 100)
        if (res.data?.available) {
          showToast(errorMessage.email_not_registered_desc, "error")
          setUserName(null);
          methods.setValue(apiConstants.email, "")
        }
      }
    }).catch(emptyFunction)
  }

  const handleUpdatePass = (data: any) => {
    setShowPassChangeModal(false)
    makePutCall(endPoints.PASSWORD, data).then((res: ApiResponseType<any>) => {
      if (res.status?.code === 200) {
        // userNavigate(userInfo?.current);
        updateProfile();
      }
    })
  }

  const updateProfile = () => {
    makePatchCall(endPoints.PROFILE, { is_password_changed: true }).then((res: ApiResponseType<any>) => {
      cookieService.saveCookie(cookieServiceParam.userType, res?.data?.user_type)
      navigate('/mfa-authentication', { state: { loginRes: userInfo?.current, isProductionOwner: isProductionOwner } })
    }).catch(emptyFunction)
  }

  return (
    <>
      <FormProvider {...methods}>
        <div className="onboarding-login">
          <div className="onboarding-login-left">
            <div className="onboarding-login-top">
              <button
                className="onboarding-login-back-btn"
                type='button'
                onClick={() => navigate('/')}
              >
                <img
                  src='/assets/images/black-arrow-left-side.svg'
                  alt="back"
                  className="onboarding-login-back-icon"
                />
              </button>
              <button
                type='button'
                onClick={() => navigate('/')}
                className="onboarding-login-signup-btn"
              >
                Not a user sign up
              </button>
            </div>
            <div className="onboarding-login-content">
              <h1 className="onboarding-login-title">
                Login
              </h1>
              <div className="onboarding-login-divider" />
              <form
                onSubmit={methods.handleSubmit(onSubmit)}
                noValidate
                className="onboarding-login-form"
              >
                <InputFieldV2
                  label={labels.email}
                  placeholder={isProductionSignUp ? 'Enter your crew app email address' : placeholder.email}
                  name={apiConstants.email}
                  type='email'
                  rules={EMAIL_VALIDATION}
                />
                {(isEmailExists || isProductionSignUp) &&
                  <InputFieldV2
                    label={labels.password}
                    placeholder={isProductionSignUp ? 'Enter your crew app password' : placeholder.password}
                    name={apiConstants.password}
                    type={isSecure ? 'password' : 'text'}
                    rules={REQUIRED_VALIDATION(labels.password)}
                    rightIconPress={() => setIsSecure((prvState: any) => !prvState)}
                    rightIcon={isSecure ? '/assets/images/eye-on.svg' : '/assets/images/eye-off.svg'}
                  />
                }
                <div className="onboarding-login-account">
                  <div className="onboarding-login-line" />
                  {!isProductionOwner ?
                    <p
                      onClick={() => navigate('/')}
                      className="onboarding-login-account-text"
                    >
                      Don’t have an account?
                    </p>
                    :
                    <p className="onboarding-login-account-text">Login with your crew account, don't have one <Link to='/'>Sign Up</Link> here</p>
                  }
                  <div className="onboarding-login-line" />
                </div>
                <button
                  type="submit"
                  className="onboarding-login-btn"
                >
                  Login
                </button>
              </form>
            </div>
          </div>
          <div className="onboarding-login-right">
            <img
              src='/assets/images/film-set.png'
              alt="film production"
              className="onboarding-login-image"
            />
            <div className="onboarding-login-year">
              <img
                src='/assets/images/yellow-6th.png'
                alt="logo"
              />
            </div>
          </div>
        </div>
      </FormProvider>
      <ChangePassword
        isShow={showPassChangeModal}
        onClose={emptyFunction}
        onSubmit={handleUpdatePass}
        hideClose
      />
    </>
  )
}

export default SignIn;
